import { P } from 'components'
import CustomButton from 'components/Buttons/CustomButton'
import ComodityCardItem from 'components/CommodityCardItem'
import { parseNumber } from 'helpers'
import { Modal, ModalBody, Spinner } from 'reactstrap'

const ModalConfirmation = ({
  isOpen,
  isOpenNonPPN,
  toggle,
  onConfirm,
  data,
  isLoading,
  isMobile,
}) => {
  return (
    <>
      <Modal
        className="modal-lg modal-dialog-centered p-5"
        isOpen={isOpen || isOpenNonPPN}
        toggle={isLoading ? () => {} : toggle}
        centered
      >
        <ModalBody>
          <div>
            <P bold>Konfirmasi Hapus Barang</P>
            <P size={isMobile ? 'regular' : 'default'}>
              {isOpenNonPPN
                ? 'Apakah kamu yakin untuk menghapus barang yang tidak dikenakan PPN?'
                : 'Apakah kamu yakin untuk menghapus barang yang dikenakan PPN?'}
            </P>
          </div>
          {data?.length > 0 && (
            <div
              className="mt-3"
              style={{
                maxHeight: '310px',
                overflowY: 'scroll',
              }}
            >
              <P className="mt-3 mb-2" size={isMobile ? 'regular' : 'default'}>
                Barang yang akan dihapus:
              </P>
              {data?.map((e, index) => {
                return (
                  <ComodityCardItem
                    key={index}
                    comodity={e?.comodity}
                    amount={e?.quantity}
                    unit={e?.unit?.value}
                    price={parseNumber(e?.price)}
                    total={e?.totalPrice}
                  />
                )
              })}
            </div>
          )}
          <div className="d-flex flex-row gap-3 mt-3">
            <CustomButton
              disabled={isLoading}
              onClick={toggle}
              block
              outline
              color="primary"
              size={isMobile ? 'regular' : 'default'}
              className="btn-cancel"
            >
              Batal
            </CustomButton>
            <CustomButton
              disabled={isLoading}
              onClick={onConfirm}
              block
              size={isMobile ? 'regular' : 'default'}
              color="danger"
            >
              {isLoading && <Spinner size="sm" className="me-2" />} Hapus
            </CustomButton>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}

export default ModalConfirmation
